// =====================================================  全局 js
import '@/utils/common'
// =====================================================  模块
import App from './App.vue'
import { createApp } from 'vue'
import { setupVab } from '@/vab'
import { setupStore } from '@/store'
import { setupRouter } from '@/router'
import { setupComponents } from '@/components'
import { setupJwt } from 'jwt-ui'

import { translateTitle } from '@/utils/i18n'
import request from '@/utils/request'
import { fillUrl } from '@/common/js/utils'
import { uploadUrl, uploadRichTextUrl, baseURL } from '@/config/index'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import ElementPlus from 'element-plus'
import dayjs from 'dayjs'
import 'jwt-ui/lib/jwt-ui.css'
// 全局变量样式
import '@/styles/index.scss'

import './registerServiceWorker'

const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
dayjs.locale('zh-cn') // 设置dayjs的语言为中文
dayjs.en.weekStart = 1
import emptyImg from '@/assets/emptyImg.png'
import errorImg from '@/assets/errorImg.png'
import { pwa } from './config'
import { handleGetCustomIcon } from '@/utils/icon'

// // 富文本
// import { Boot } from '@wangeditor/editor'
// import attachmentModule from '@wangeditor/plugin-upload-attachment'
// // 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
// Boot.registerModule(attachmentModule)

/**
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
// import { baseURL, pwa } from './config'
// import { isExternal } from '@/utils/validate'

// if (process.env.NODE_ENV === 'production' && !isExternal(baseURL)) {
//   const { mockXHR } = require('@/utils/static')
//   mockXHR()
// }

if (pwa) require('./registerServiceWorker')

/**
 * @description 生产环境启用组件初始化，编译，渲染和补丁性能跟踪。仅在开发模式和支持 Performance.mark API的浏览器中工作。
 */
if (process.env.NODE_ENV === 'development') {
  app.config.performance = true
}

// 屏蔽警告信息
app.config.warnHandler = () => null

const debounce = (fn, delay) => {
  let timer = null
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}

setupVab(app)
setupJwt(app, {
  translateTitle: translateTitle, // 翻译函数
  request: request, // 请求函数
  fillUrl: (url, w, h, q = 50) => fillUrl(url, w, h, q), // 图片路径补全函数
  uploadImgUrl: uploadUrl, // 图片上传地址
  uploadRichTextUrl: uploadRichTextUrl, // 上传富文本路径
  txCosUploadFileUrl: baseURL + '/company/config', // 腾讯 cos上传文件地址
  emptyImgUrl: emptyImg, // 默认图片地址
  errorImgUrl: errorImg, // 图片加载错误地址
  defaultImgNameLength: 3,
  defaultImgNameKey: 'title',
  imgUploadResKey: 'relative_path', // 图片上传返回地址key responseKey
  tablePageSizes: [10, 15, 20, 30, 40, 50],
  customIconObj: handleGetCustomIcon(), // 自定义图标
  autoSaveIntervalTime: 1000 * 10, // 自动保存表单间隔时间
  autoSaveForm: false, // 自动保存表单
  pageSizeKey: 'per_page',
})
setupComponents(app)
setupStore(app)
setupRouter(app)
  .isReady()
  .then(() => app.mount('#app'))
